import { EXAM_PUBLIC_STORAGE } from '@/Module/Exam/Constant';

export const normalizeExamHtml = (html: string) => {
  return html.replace(/src="([^"]+)"/gm, `src="${EXAM_PUBLIC_STORAGE}$1"`);
};
